import React, { useMemo } from "react";
import styled from "styled-components";
import { Badge } from "@sonder/ui/source/styled/fragments/Badge";
import { colors } from "@sonder/ui/source/styled/theme";

const StyledPriorityBadge = styled(Badge)<{ hidden?: boolean }>`
  border-style: dotted;
  display: ${props => props.hidden && "none"};
  &:hover {
    border-style: solid;
    color: ${props => !props.color && colors.black};
  }
`;

export interface ItemDetails {
  color?: "red" | "orange" | "yellow" | "gray";
  content: string;
  value: number | null;
}
export const PRIORITY_ITEMS: ItemDetails[] = [
  { content: "P1", value: 1, color: "red" },
  { content: "P2", value: 2, color: "orange" },
  { content: "P3", value: 3, color: "yellow" },
  { content: "P4", value: 4, color: "gray" },
  { content: "P5", value: 5, color: "gray" },
  { content: "P", value: null },
];

interface PriorityBadgeProps {
  className?: string;
  priority: number | null;
}
export const PriorityBadge = ({ className, priority }: PriorityBadgeProps) => {
  const currentItem = useMemo(
    () => PRIORITY_ITEMS.find(({ value }) => value === priority),
    [priority],
  );

  if (!currentItem) return null;
  return (
    <StyledPriorityBadge className={className} color={currentItem.color}>
      {currentItem.content}
    </StyledPriorityBadge>
  );
};
